import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import DialogContent from '@mui/material/DialogContent';
import { EmbersDateSelect } from '../../../../date';
import { EmbersModal } from '../../../../modal/modal';
import { EmbersModalTitle } from '../../../../modal/modalTitle';
import { EmbersModalFooter } from '../../../../modal/modalFooter';
import { FilterTags } from './filtersTags';
import { useFilterTags } from './useFilterTags';
import { getDateOption, getOption, isDateEle, isArrayEqual, getRemovedValueByCode, cloneFilters } from './utils';
import { ROOT_PREFIX, ModalFiltersContainer, DRAWER_ROOT_PREFIX, StyledDrawer } from './filtersModalStyles';
var dateBlankValue = {
  value: null,
  selection: null
};
export var FiltersModal = function FiltersModal(props) {
  var children = props.children,
    _props$defaultFilterI = props.defaultFilterItems,
    defaultFilterItems = _props$defaultFilterI === void 0 ? [] : _props$defaultFilterI,
    onClose = props.onClose,
    onSave = props.onSave,
    onFilterChange = props.onFilterChange,
    isMobile = props.isMobile,
    _props$codeKey = props.codeKey,
    codeKey = _props$codeKey === void 0 ? 'code' : _props$codeKey,
    _props$labelKey = props.labelKey,
    labelKey = _props$labelKey === void 0 ? 'label' : _props$labelKey,
    dateFormatString = props.dateFormatString;
  var intl = useIntl();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    filtersValue = _useState2[0],
    setFiltersValue = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    saveButtonDisabled = _useState4[0],
    setSaveButtonDisabled = _useState4[1];
  var _useFilterTags = useFilterTags({
      defaultFilterItems: defaultFilterItems,
      onFilterChange: onFilterChange,
      onTagRemove: function onTagRemove(filterName, code) {
        onFilterChange({
          filterName: filterName,
          value: code,
          fromModal: true
        });
        setFiltersValue(function (preVal) {
          var data = preVal[filterName];
          var newVal = _objectSpread(_objectSpread({}, preVal), {}, _defineProperty({}, filterName, Array.isArray(data) ? getRemovedValueByCode(data, code, codeKey) : (data === null || data === void 0 ? void 0 : data.type) === 'date' ? dateBlankValue : {}));
          return newVal;
        });
      },
      onClearAll: function onClearAll() {
        // a trick to indicate that the filters are cleared
        onFilterChange({
          filterName: '',
          value: '',
          fromModal: true
        });
        setFiltersValue({});
      },
      codeKey: codeKey,
      labelKey: labelKey,
      dateFormatString: dateFormatString
    }),
    filterItems = _useFilterTags.filterItems,
    handleFilterChange = _useFilterTags.handleFilterChange,
    handleTagDelete = _useFilterTags.handleTagDelete,
    handleClearAll = _useFilterTags.handleClearAll;
  useEffect(function () {
    React.Children.forEach(children || [], function (child) {
      var _child$props = child.props,
        name = _child$props.name,
        value = _child$props.value,
        selection = _child$props.selection;
      var data = isDateEle(child) ? {
        value: value,
        selection: selection,
        type: 'date'
      } : value;
      if (name) {
        setFiltersValue(function (preVal) {
          return _objectSpread(_objectSpread({}, preVal), {}, _defineProperty({}, name, data));
        });
      }
    });
  }, []);
  useEffect(function () {
    setSaveButtonDisabled(isArrayEqual(codeKey, defaultFilterItems, filterItems));
  }, [filterItems]);
  var handleSave = function handleSave() {
    onSave(filtersValue, filterItems);
  };
  var getChildProps = function getChildProps(child, type) {
    var name = child.props.name;
    if (name) {
      var childProps;
      if (child.type === EmbersDateSelect) {
        var _name, _name2;
        childProps = {
          value: (_name = filtersValue[name]) === null || _name === void 0 ? void 0 : _name.value,
          selection: (_name2 = filtersValue[name]) === null || _name2 === void 0 ? void 0 : _name2.selection,
          onPickRange: function onPickRange(range, selection) {
            var _selection$option;
            var value = {
              value: selection === null || selection === void 0 ? void 0 : selection.value,
              selection: selection === null || selection === void 0 ? void 0 : selection.option,
              type: type,
              range: range
            };
            var option = _objectSpread(_objectSpread({}, getDateOption(range, codeKey, labelKey, dateFormatString)), {}, {
              filterName: name
            });
            setFiltersValue(function (preVal) {
              return _objectSpread(_objectSpread({}, preVal), {}, _defineProperty({}, name, value));
            });
            handleFilterChange({
              filterName: name,
              value: value,
              reason: selection !== null && selection !== void 0 && (_selection$option = selection.option) !== null && _selection$option !== void 0 && _selection$option.value ? 'selectOption' : 'removeOption',
              option: option,
              multiple: false,
              isDate: true,
              fromModal: true
            });
          },
          hideCustomPicker: isMobile
        };
      } else {
        childProps = {
          value: filtersValue[name],
          onChange: function onChange(value, reason, option) {
            setFiltersValue(function (preVal) {
              return _objectSpread(_objectSpread({}, preVal), {}, _defineProperty({}, name, value));
            });
            handleFilterChange({
              filterName: name,
              value: value,
              reason: reason,
              option: _objectSpread(_objectSpread({}, getOption(option, codeKey, labelKey)), {}, {
                filterName: name
              }),
              multiple: type === 'multiple',
              isDate: false,
              fromModal: true
            });
          }
        };
      }
      return childProps;
    }
    return {};
  };
  if (isMobile) {
    return /*#__PURE__*/React.createElement(FiltersDrawer, {
      open: true,
      onClose: onClose,
      title: intl.formatMessage({
        id: 'embers.filter.filterTitle',
        defaultMessage: 'Filters'
      }),
      buttonDefs: {
        primary: {
          level: 'primary',
          colorTheme: 'purple',
          onClick: handleSave,
          disabled: saveButtonDisabled,
          label: intl.formatMessage({
            id: 'embers.button.apply',
            defaultMessage: 'Apply'
          })
        }
      }
    }, /*#__PURE__*/React.createElement(FilterTags, {
      showLabel: false,
      className: "tags-in-modal",
      isMobile: isMobile,
      data: filterItems,
      onTagDelete: handleTagDelete,
      onClearAll: handleClearAll
    }), /*#__PURE__*/React.createElement(ModalFiltersContainer, {
      className: "".concat(ROOT_PREFIX, "-modalContainer")
    }, children && cloneFilters(children, getChildProps)));
  }
  return /*#__PURE__*/React.createElement(EmbersModal, {
    open: true,
    title: intl.formatMessage({
      id: 'embers.filter.filterTitle',
      defaultMessage: 'Filters'
    }),
    type: "transactional",
    onClose: onClose,
    buttonDefs: {
      primary: {
        level: 'primary',
        colorTheme: 'purple',
        onClick: handleSave,
        disabled: saveButtonDisabled
      }
    }
  }, /*#__PURE__*/React.createElement(FilterTags, {
    showLabel: false,
    className: "tags-in-modal",
    isMobile: isMobile,
    data: filterItems,
    onTagDelete: handleTagDelete,
    onClearAll: handleClearAll
  }), /*#__PURE__*/React.createElement(ModalFiltersContainer, {
    className: "".concat(ROOT_PREFIX, "-modalContainer")
  }, children && cloneFilters(children, getChildProps)));
};
var FiltersDrawer = function FiltersDrawer(_ref) {
  var title = _ref.title,
    open = _ref.open,
    onClose = _ref.onClose,
    buttonDefs = _ref.buttonDefs,
    children = _ref.children;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: createTheme({})
  }, /*#__PURE__*/React.createElement(StyledDrawer, {
    anchor: 'top',
    open: open,
    onClose: onClose,
    className: "".concat(DRAWER_ROOT_PREFIX, "-root")
  }, /*#__PURE__*/React.createElement(EmbersModalTitle, {
    title: title,
    type: 'transactional',
    closeable: false
  }), /*#__PURE__*/React.createElement(DialogContent, null, children), /*#__PURE__*/React.createElement(EmbersModalFooter, {
    actionProps: {
      primary: _objectSpread({
        level: 'primary',
        colorTheme: 'purple',
        label: intl.formatMessage({
          id: 'embers.button.save',
          defaultMessage: 'Save'
        }),
        size: 'medium'
      }, buttonDefs === null || buttonDefs === void 0 ? void 0 : buttonDefs.primary),
      secondary: _objectSpread({
        level: 'secondary',
        colorTheme: 'purple',
        drawingStyle: 'outlined',
        label: intl.formatMessage({
          id: 'embers.button.cancel',
          defaultMessage: 'Cancel'
        }),
        size: 'medium',
        onClick: onClose
      }, buttonDefs === null || buttonDefs === void 0 ? void 0 : buttonDefs.secondary)
    }
  })));
};